module.exports = __webpack_public_path__ + "img/clock-border.ff2bca7a.svg";